<template>
  <v-dialog v-model="show" max-width="720">
    <v-card class="pa-2">

      <div class="d-flex align-center">

        <v-icon
          class="mx-2"
          color="bb-secondary"
          v-text="'mdi-share-variant'"
        />

        <v-text-field
          ref="input"
          :value="link"
          @click="selectText"
          class="grow mx-2"
          color="bb-primary"
          hide-details
          autofocus
          outlined
          readonly
          dense
        />

        <Btn color="bb-primary" @click="copy" icon>
          <v-icon v-text="'mdi-content-copy'"/>
        </Btn>

      </div>

      <div class="share-story d-flex align-center mx-2 mt-2 pt-2">
        <div class="share-story-copy mr-3">
          <strong>Story image</strong>
          <span>For Instagram or WhatsApp</span>
        </div>
        <Btn
          class="share-story-btn"
          color="bb-primary"
          height="40"
          :loading="storyBusy"
          :disabled="storyBusy || !id"
          @click="$emit('story')"
          outlined
        >
          <v-icon left v-text="'mdi-image-outline'"/>
          {{ storyReady ? 'Share image' : 'Share as image' }}
        </Btn>
      </div>

      <p v-if="storyError" class="share-story-error mx-2 mt-2 mb-0" role="alert">{{ storyError }}</p>

    </v-card>
  </v-dialog>
</template>

<script>

  import { Btn } from '@/components';
  import { appBase } from '@/utils/basePath';

  export default {
    components: { Btn },
    props: {
      value: null,
      id: String,
      storyBusy: Boolean,
      storyReady: Boolean,
      storyError: String
    },
    data() {
      return {
        show: !!this.value
      }
    },
    computed: {
      link() {
        var path = window.location.origin + (appBase || "/");
        if ( this.id ) path += '?id=' + encodeURIComponent(this.id);
        return path;
      }
    },
    watch: {
      value( value ) {
        this.show = !!value;
      },
      show( value ) {
        this.$emit( 'input', value );
      }
    },
    methods: {
      input() {
        return this.$refs.input
          ? this.$refs.input.$el.getElementsByTagName('input')[0]
          : null;
      },
      selectText() {
        const input = this.input();
        if ( input ) {
          input.focus();
          input.selectionStart = 0;
          input.selectionEnd = this.link.length;
        }
      },
      copy() {
        this.selectText();
        if ( document.execCommand )
          document.execCommand('copy');
      }
    }
  }
</script>

<style>
  .share-story {
    border-top: 1px solid var(--builder-line, #dedfd7);
  }
  .share-story-copy {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
    font-size: 14px;
    line-height: 1.3;
    color: var(--builder-ink, #252c22);
  }
  .share-story-copy span {
    font-size: 12px;
    color: #62695e;
  }
  .share-story-btn.v-btn {
    flex: 0 0 auto;
    text-transform: none;
    letter-spacing: normal;
  }
  .share-story-error {
    font-size: 13px;
    color: #b3261e;
  }
</style>
